import * as tracking from 'dibs-tracking';
import serverVars from 'server-vars';

import { PlacementOptions, Channel } from './types';

const CONTACT_1STDIBS_CATEGORY = 'contact 1stdibs';

export const trackCategorySelect = (categoryKey: string): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'category selected',
        label: categoryKey,
    });
};

export const trackTopicSearchSelect = (topicKey: string): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'topic search selected',
        label: `topic search selected: ${topicKey}`,
    });
};

export const trackTopicSelect = (topicKey: string): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'topic selected',
        label: topicKey,
    });
};

export const trackSubmit = (topicKey: string | null): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'submitted message',
        label: topicKey,
    });
};

export const trackPhoneNumberClick = (phoneNumber: string): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'phone number clicked',
        label: phoneNumber,
    });
};

export const trackTopicSearchClick = (): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'topic searched',
        label: 'topic search box clicked',
    });
};

export const trackContact1stdibsOpened = (placement: PlacementOptions): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'support modal opened',
        label: placement,
    });
};

export const trackChannelSelected = (channel: Channel): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'channel selected',
        label: channel,
    });
};

export const trackChatInitiated = (topicKey: string): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'chat initiated',
        label: topicKey,
    });
};

export const existingChatLoaded = (): void => {
    const pageType = serverVars.get('settings.pageType');

    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'existing chat loaded',
        label: pageType,
    });
};

export const chatCtaDisplayed = (isAgentAvailable: boolean): void => {
    tracking.trackEvent({
        category: CONTACT_1STDIBS_CATEGORY,
        action: 'chat CTA displayed',
        label: `agents ${isAgentAvailable ? 'online' : 'offline'}`,
    });
};
